export default __webpack_public_path__ + "static/media/login_bg.d327d9f3.png";